var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.processo.id
    ? _c(
        "validation-observer",
        { ref: "validation", attrs: { tag: "form" } },
        [
          _vm.showModalDespacho
            ? _c("app-modal-selecionar-modelo-notificacao", {
                attrs: {
                  tiposModelo: _vm.tiposModelo,
                  titulo: "Modelos de Despacho",
                  showModal: _vm.showModalDespacho
                },
                on: {
                  closeModal: _vm.fecharModalDespacho,
                  setTextoDespacho: _vm.setTextoDespacho
                }
              })
            : _vm._e(),
          _c(
            "el-card",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c(
                "el-row",
                { staticClass: "margin-medium-top", attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "center", attrs: { span: 8 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Nome do Interessado:",
                          content: _vm.processo.nomeRazaoSocialInteressado
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Número do processo:",
                          content: _vm.processo.numeroProcesso
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "CPF do Interessado:",
                          content: _vm.processo.cpfCnpjInteressado
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Tipo de Processo:",
                          content: _vm.processo.tipo
                        }
                      })
                    ],
                    1
                  ),
                  _c("app-opcoes-header-analise", {
                    staticClass: "right",
                    attrs: {
                      idProcesso: _vm.processo.id,
                      numeroProcesso: _vm.processo.numeroProcesso,
                      tipoProcesso: _vm.processo.tipo.codigo,
                      protocolo: _vm.processo.numeroProtocolo,
                      btnSolicitarInformacao: false,
                      btnRetificacao: false
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c(
                "div",
                { staticClass: "radios-despacho-parecer" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c(
                                "div",
                                { staticClass: "container-buttons" },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { name: "parecer" },
                                      model: {
                                        value: _vm.isGerarCustas,
                                        callback: function($$v) {
                                          _vm.isGerarCustas = $$v
                                        },
                                        expression: "isGerarCustas"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "padding input",
                                          class: { erro: errors.length }
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: {
                                                label: true,
                                                border: true
                                              }
                                            },
                                            [_vm._v("Gerar custas agrárias")]
                                          ),
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: {
                                                label: false,
                                                border: true
                                              }
                                            },
                                            [_vm._v("Despacho")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1585150481
                    )
                  })
                ],
                1
              )
            ]
          ),
          _c(
            "el-card",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _vm.isGerarCustas === true
                ? _c("app-geracao-custas", {
                    attrs: {
                      custa: _vm.custa,
                      valoresFixos: _vm.valoresFixos,
                      exibirLabelCustas: false,
                      exibirNumeroModulos: true,
                      exibirFatorLocalizacao: false,
                      exibirElaboracaoPublicacao: true,
                      credenciadoVistoria: _vm.processo.credenciadoVistoria,
                      credenciadoGeomensor: _vm.processo.credenciadoGEO,
                      processo: _vm.processo
                    }
                  })
                : _c(
                    "div",
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "flex-despacho" },
                                    [
                                      _c("p", { staticClass: "label" }, [
                                        _vm._v("Despacho"),
                                        _c(
                                          "span",
                                          { staticClass: "required" },
                                          [_vm._v("  *  ")]
                                        )
                                      ]),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: { click: _vm.openModalDespacho }
                                        },
                                        [
                                          _vm._v("Modelo  "),
                                          _c("div", {
                                            staticClass: "fa fa-file"
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c("app-editor-texto", {
                                    ref: "editorTexto",
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    on: { onTextChange: _vm.onTextChange },
                                    model: {
                                      value: _vm.textoDespacho,
                                      callback: function($$v) {
                                        _vm.textoDespacho = $$v
                                      },
                                      expression: "textoDespacho"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          30055700
                        )
                      }),
                      _c("app-anexo", {
                        attrs: {
                          id: "upload-anexo-despacho",
                          files: _vm.anexos,
                          tipoExibir: "ANEXO_ANALISE"
                        },
                        on: {
                          uploadFile: _vm.uploadFile,
                          removeFile: _vm.removeFile,
                          downloadDocumentoCadastro:
                            _vm.downloadDocumentoCadastro
                        }
                      }),
                      _c("app-radios-tramitacao", {
                        attrs: {
                          radios: _vm.acoesRadio,
                          isDecisao: _vm.isDecisao,
                          radioInicial: null
                        },
                        on: { changeRadio: _vm.changeRadio }
                      })
                    ],
                    1
                  ),
              _c("el-row", [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { type: "default" },
                        on: { click: _vm.cancelar }
                      },
                      [
                        _c("i", { staticClass: "fa fa-times" }),
                        _vm._v("  Cancelar")
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { type: "success" },
                        on: { click: _vm.finalizar }
                      },
                      [
                        _c("i", { staticClass: "fa fa-chevron-right" }),
                        _vm._v("  Finalizar")
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-160d47e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-160d47e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/GerarCustas.vue
// module id = null
// module chunks = 